<template>
  <ValidationProvider :name="$attrs.label" :rules="rules">
    <v-combobox
      v-model="inputValue"
      slot-scope="{ errors, valid }"
      :error-messages="errors"
      :items="items"
      :success="valid && success"
      v-bind="$attrs"
      v-on="$listeners"
    />
  </ValidationProvider>
</template>
<script>
import { ValidationProvider } from 'vee-validate';

export default {
  name: 'TextInput',
  components: {
    ValidationProvider,
  },
  props: {
    value: { type: [String, Object], default: null },
    items: { type: Array, default: () => [] },
    rules: {
      type: [Object, String],
      default: '',
    },
    success: { type: Boolean, default: false },
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
        this.$emit('update', value);
      },
    },
  },
};
</script>
<style scoped></style>
